<template>
  <div class="tw-rounded-lg tw-shadow-md tw-p-5 tw-mb-5 tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-bg-dark-blue-700 hover:tw-shadow-lg box">
    <div class="tw-text-sm tw-font-semibold has-text-grey-dark tw-mb-2">{{ task.name }}</div>
    <p class="tw-text-xs tw-text-gray-400 tw-mb-4">{{ task.description }}</p>
    <div class="tw-flex tw-justify-between tw-items-center">
      <span :class="['tw-px-2 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium', 
        task.status === 'todo' ? 'tw-bg-blue-900 tw-text-blue-300' : 'tw-bg-green-900 tw-text-green-300']">
        {{ task.status }}
      </span>
      <div class="tw-flex tw--space-x-2">
        <div v-for="(assignee, index) in task.assignees" :key="index" 
             class="tw-w-6 tw-h-6 tw-rounded-full tw-bg-indigo-900 tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-semibold tw-text-white tw-border-2 tw-border-indigo-800"
             :style="{ zIndex: task.assignees.length - index }">
          {{ assignee.charAt(0).toUpperCase() }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TaskCard',
  props: {
    task: {
      type: Object,
      required: true,
      validator: (task) => {
        return task.name && task.description && task.status && Array.isArray(task.assignees);
      }
    }
  }
}
</script>

<style scoped>
/* You can add any additional custom styles here if needed */
</style>
